/**
 * the HTML5 autofocus property can be finicky when it comes to dynamically loaded
 * templates and such with AngularJS. Use this simple directive to
 * tame this beast once and for all.
 *
 * Usage:
 * <input type="text" auto-focus-input>
 *
 * License: MIT
 */
// see https://gist.github.com/mlynch/dd407b93ed288d499778
// autofocus only works if the input is in the initial page load
// switching routes does not honor autofocus, known issue with angular
angular
    .module('signalview.utils')

    .directive('autoFocusInput', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element, attrs) {
                    function focus() {
                        $timeout(
                            function () {
                                $element[0].focus();
                            },
                            0,
                            false
                        );
                    }

                    $scope.$watch(
                        function () {
                            return attrs.autoFocusInput;
                        },
                        function (newVal, oldVal) {
                            if (newVal === 'true' && newVal !== oldVal) {
                                focus();
                            }
                        }
                    );
                    if (attrs.autoFocusInput !== 'false') {
                        focus();
                    }
                },
            };
        },
    ]);
